import { useUserStore } from '@/stores/user';

export const brandName = () => {
  const { hasFeatureFlag } = useUserStore();
  return {
    brandName: hasFeatureFlag('treatwell-brand')
      ? 'Treatwell Expert'
      : 'Salonized',
  };
};

export const brandNamePay = () => {
  const { hasFeatureFlag } = useUserStore();
  return {
    brandNamePay: hasFeatureFlag('treatwell-brand')
      ? 'Treatwell Pay'
      : 'Salonized Pay',
  };
};
